@if (adverseParties$ | async; as adverseParties) {
<div>
  @if (adverseParties.length === 0) {
  <div>
    <h2 class="text-center" data-pgr-id="noAdversePartiesMessage">
      Subrogation has not been opened on an adverse party.
    </h2>
  </div>
  } @if (adverseParties.length > 0) {
  <div data-pgr-id="adversePartiesList">
    @for ( party of adverseParties; track trackBySubroObligationId(i, party);
    let i = $index) {
    <div
      class="
        mat-elevation-z2
        mb-xs
        p-xs
        adverse-party-card
        overflow-auto
        card-border-radius
      "
    >
      <cla-adverse-party-header
        [claimNumber]="claimNumber"
        [adverseParty]="party"
        [detailCodes]="subrogationSummaryCodes$ | async"
        [partyNumber]="i + 1"
        [totalNumberOfParties]="adverseParties.length"
      >
      </cla-adverse-party-header>
      <cla-adverse-party-details
        [adverseParty]="party"
        [detailCodes]="subrogationSummaryCodes$ | async"
        [claimNumber]="claimNumber"
      ></cla-adverse-party-details>
    </div>
    }
  </div>
  }
</div>
} @else { @if (showError) {
<h2 class="text-center" data-pgr-id="AdversePartiesErrorMessage">
  An error has occured while retrieving adverse parties.
</h2>
} }
